<template>
    <div v-if="!viewMode" class="fields-group">
        <p v-if="group.title">{{group.title}}</p>
        <field-wrapper v-for="(question) in group.questions"
                       :key="question.id"
                       :type="question.type"
                       :value="getAnswerById(question.id)"
                       :id="question.id"
                       :options="question.options"
                       :required="question.required"
                       :label="question.text"
                       :clone="question.clone"
                       @input="handleInput(question.id, $event)"
        >
        </field-wrapper>
    </div>
    <div v-else class="fields-group">
        <p v-if="group.title">{{group.title}}</p>
        <field-wrapper-disabled v-for="(question, index) in group.questions"
                       :key="question.id"
                       :type="question.type"
                       :value="answers[index].value"
                       :id="question.id"
                       :options="question.options"
                       :label="question.text">
        </field-wrapper-disabled>
    </div>
</template>

<script>

    import FieldWrapper from "../common/fields/FieldWrapper";
    import FieldWrapperDisabled from "../common/fields/FieldWrapperDisabled";
    import {mapGetters} from 'vuex'

    export default {
        name: 'field-group',
        components: {FieldWrapperDisabled, FieldWrapper},
        props: {
            group: Object,
            answers: Array,
            viewMode: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return{

            }
        },
        computed: {
            ...mapGetters('questionnaire',[
                'getAnswerById'
                // ...
            ])
        },
        methods: {
            handleInput(id, e) {
                this.$store.commit('questionnaire/setAnswerValue', {id: id, value: e});
            },
            getAnswer(id) {
                let answer = this.getAnswerById(id);
                return !answer ? null : answer.value
            }
        },
    }
</script>


<style scoped>

</style>
